function Pager(element) {
	const p = {
		root: undefined,
		pages: [],
		currentPage: undefined,
		initialised: false,
		prevButton: undefined,
		nextButton: undefined,
	}

	p.init = function () {
		const pager = element;
		console.log({pager})
		if (!pager) {
			return;
		}

		p.root = pager;

		const pages = Array.from(p.root.querySelectorAll('.pager__page'));
		if (!pages.length) {
			return;
		}

		p.prevButton = p.root.querySelector('.pager__prev');
		p.nextButton = p.root.querySelector('.pager__next');

		if(p.prevButton) {
			p.prevButton.addEventListener('click', p.prev);
		}

		if(p.nextButton) {
			p.nextButton.addEventListener('click', p.next);
		}

		p.pages = pages;
		p.initialised = true;
		console.log('initialised');


		p.jumpTo(pages[0]);
	}

	p.jumpTo = function (requestedPage) {
		if (!p.initialised) {
			console.log('not initialised')
			return;
		}

		p.pages.forEach((page, index) => {
			if (page === requestedPage) {
				p._activatePage(page);
			}
			else {
				p._deactivatePage(page);
			}
		});

		p.currentPage = requestedPage;
	}

	p.prev = function() {
		const currentIndex = p._getPageIndex(p.currentPage);
		let newIndex = currentIndex - 1;
		if (newIndex < 0) {
			// wraparound to end
			newIndex = p.pages.length - 1;
		}

		p.jumpTo(p.pages[newIndex]);
	}

	p.next = function() {
		const currentIndex = p._getPageIndex(p.currentPage);

		let newIndex = currentIndex + 1;
		if (newIndex >= p.pages.length) {
			newIndex = 0; // wraparound to start
		}

		console.table([`new ${newIndex}`, `curr ${currentIndex}`])

		p.jumpTo(p.pages[newIndex]);
	}

	/**
	 * Has same return as Array.findIndex
	 * 
	 * 
	 * @param page element 
	 * @returns int
	 */
	p._getPageIndex = function (page) {
		const index = p.pages.indexOf(page);

		return index;
	}

	p._activatePage = function(page) {
		page.classList.remove('pager__page--hidden');
		page.classList.add('pager__page--active');
	}

	p._deactivatePage = function(page) {
		page.classList.remove('pager__page--active');
		page.classList.add('pager__page--hidden');
	}

	return p;
}

export function setupPager()
{
	const pagers = document.querySelectorAll('.pager');
	
	if(!pagers.length) {
		return;
	}

	pagers.forEach((element) => {
		const pager = new Pager(element);
		pager.init();
	})
}




// WEBPACK FOOTER //
// ./scripts/modules/menu-pager.js